module.exports = __webpack_public_path__ + "img/P150T_weapon_141.1bf4d5dc.png";